import React from 'react';

const Financeurs = () => {
    return (

        <div className="bandeau">
          
         

           
            <div className='financeurs'>
                <h4>Organisé par :</h4>
                <div className="organisateurs">
                  <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/organisateurs_aj.png" alt="" />
                </div>
                <h4>Avec le soutien de :</h4>
                <div className="logo">
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture1.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture2.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture3.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture4.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture5.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture6.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture7.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture8.png" alt="" />
                    <img src="https://agorajobs.fr/preinscription_exposants_2024/assets/Capture9.svg" alt="" />
                </div>
            </div>
        </div>
    );
};

export default Financeurs;